import React, { useEffect } from 'react';
import { Switch, Route, Redirect, useParams, useHistory, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Dashboard from './DashBoard';
import GA4 from './GA4';
import GA4PP from './GA4PP';
import GoogleAds from './GoogleAds';
import MetaAds from './Meta';
import Line from './Line';
import SEO from './SEO';
// import "./index.module.css";cd 
import Compare from './Compare';
import MarketAnalytic from './MarketAnalytic';
import GoogleMapsReview from './GoogleMapsReview';
const supportedLanguages = ['en', 'ja', 'vi', 'ko'];

function MarketingRouter() {
  const { i18n } = useTranslation();
  const { lang } = useParams();
  const history = useHistory();
  const location = useLocation();

  useEffect(() => {
    if (!lang) return;

    if (supportedLanguages.includes(lang) && i18n.language !== lang) {
      i18n.changeLanguage(lang);
      return;
    }

    if (!supportedLanguages.includes(lang)) {
      const parts = location.pathname.split('/').filter(Boolean);
      const tail = parts.slice(2).join('/');
      history.replace(`/marketing/en${tail ? `/${tail}` : ''}`);
    }
  }, [lang, i18n, history, location.pathname]);

  return (
    <Switch>
      <Route path="/marketing/:lang/ga4-vn" component={GA4} exact />
      <Route path="/marketing/:lang/ga4-cam" component={GA4PP} exact />
      <Route path="/marketing/:lang/google-ads" component={GoogleAds} exact />
      <Route path="/marketing/:lang/meta-ads" component={MetaAds} exact />
      <Route path="/marketing/:lang/line" component={Line} exact />
      <Route path="/marketing/:lang/compare" component={Compare} exact />
      <Route path="/marketing/:lang/market-analytic" component={MarketAnalytic} exact />
      <Route path="/marketing/:lang/google-maps-reviews" component={GoogleMapsReview} exact />
      <Route path="/marketing/:lang" component={Dashboard} exact />
      <Route path="/marketing/:lang/seo" component={SEO} exact />
      <Redirect exact from="/marketing" to="/marketing/en" />
      <Redirect from="/marketing/*" to="/marketing/en" />
    </Switch>
  );
}

export default MarketingRouter;



